import { get } from "lodash";
import { ChannelConfigType } from "src/types/channelConfig";
import { ENTRY_FORM_CODE } from "src/constants/entryForm";
import { I18Text } from "src/types/i18Text";
import dynamic from "next/dynamic";
import { Banner as BannerType } from "../../types/banner";
import { ActiveInputCodesType } from "../../types/productCategory";

const EntryFormBanner = dynamic(() => import("../EntryForm/EntryFormBanner"), {
  loading: () => <div />,
});

const ContactUs = dynamic(() => import("../LandingPage/ContactUs"), {
  loading: () => <div />,
});

const PartnerHealthProductCategoryDetail = dynamic(
  () => import("../ProductCategory/PartnerHealthProductCategoryDetail"),
  {
    loading: () => <div />,
  }
);
const PartnerHealthTopupProductCategoryDetail = dynamic(
  () => import("../ProductCategory/PartnerHealthTopUpProductCategoryDetail"),
  {
    loading: () => <div />,
  }
);
const THGPAProductCateogryDetail = dynamic(
  () => import("../ProductCategory/THGPAProductCategoryDetail"),
  {
    loading: () => <div />,
  }
);
const PartnerPAProductCategoryDetail = dynamic(
  () => import("../ProductCategory/PartnerPAProductCategoryDetail"),
  {
    loading: () => <div />,
  }
);
const ChildHealthProductCategoryDetail = dynamic(
  () => import("../ProductCategory/ChildHealthProductCategoryDetail"),
  {
    loading: () => <div />,
  }
);
const CriticalIllnessProductCategoryDetail = dynamic(
  () => import("../ProductCategory/CriticalIllnessProductCategoryDetail"),
  {
    loading: () => <div />,
  }
);
const PartnerCriticalIllnessProductCategoryDetail = dynamic(
  () =>
    import("../ProductCategory/PartnerCriticalIllnessProductCategoryDetail"),
  {
    loading: () => <div />,
  }
);
const ScbForeignWorkerPAProductCategoryDetail = dynamic(
  () => import("../ProductCategory/ScbForeignWorkerPAProductCategoryDetail"),
  {
    loading: () => <div />,
  }
);
const HealthProductCategoryDetail = dynamic(
  () =>
    import(
      "../ProductCategory/HealthProductCategoryDetail/HealthProductCategoryDetail"
    ),
  {
    loading: () => <div />,
  }
);
const HealthTopUpProductCategoryDetail = dynamic(
  () => import("../ProductCategory/HealthTopUpProductCategoryDetail"),
  {
    loading: () => <div />,
  }
);
const KSCChildHealthProductCategoryDetail = dynamic(
  () => import("../ProductCategory/KSCChildHealthProductCategoryDetail"),
  {
    loading: () => <div />,
  }
);
const KSCHealthProductCategoryDetail = dynamic(
  () => import("../ProductCategory/KSCHealthProductCategoryDetail"),
  {
    loading: () => <div />,
  }
);
const KSCHealthTopUpProductCategoryDetail = dynamic(
  () => import("../ProductCategory/KSCHealthTopUpProductCategoryDetail"),
  {
    loading: () => <div />,
  }
);
const HGDHealthProductCategoryDetail = dynamic(
  () => import("../ProductCategory/HGDHealthProductCategoryDetail"),
  {
    loading: () => <div />,
  }
);
const PAProductCategoryDetail = dynamic(
  () => import("../ProductCategory/PAProductCategoryDetail"),
  {
    loading: () => <div />,
  }
);
const HGDCriticalIllnessProductCategoryDetail = dynamic(
  () => import("../ProductCategory/HGDCriticalIllnessProductCategoryDetail"),
  {
    loading: () => <div />,
  }
);
const HGDPAProductCategoryDetail = dynamic(
  () => import("../ProductCategory/HGDPAProductCategoryDetail"),
  {
    loading: () => <div />,
  }
);
const HGDHealthTopUpProductCategoryDetail = dynamic(
  () => import("../ProductCategory/HgdHealthTopUpProductCategoryDetail"),
  {
    loading: () => <div />,
  }
);
const CancerProductCategoryDetail = dynamic(
  () =>
    import(
      "../ProductCategory/CancerProductCategoryDetail/CancerProductCategoryDetail"
    ),
  {
    loading: () => <div />,
  }
);
const RetailMotorProductCategoryDetail = dynamic(
  () =>
    import(
      "../ProductCategory/RetailMotorProductCategoryDetail/MotorProductCategoryDetail"
    ),
  {
    loading: () => <div />,
  }
);
const EvRetailMotorProductCategoryDetail = dynamic(
  () =>
    import(
      "../ProductCategory/RetailMotorProductCategoryDetail/EvMotorProductCategoryDetail"
    ),
  {
    loading: () => <div />,
  }
);
const CHUBBTravelProductCategoryDetail = dynamic(
  () =>
    import(
      "../ProductCategory/CHUBBTravelProductCategory/CHUBBTravelProductCategoryDetail"
    ),
  {
    loading: () => <div />,
  }
);
const AXAChildHealthProductCategoryDetail = dynamic(
  () =>
    import(
      "../ProductCategory/AXAChildHealthProductCategoryDetail/AXAChildHealthProductCategoryDetail"
    ),
  {
    loading: () => <div />,
  }
);
const LgibHealthProductCategoryDetail = dynamic(
  () => import("../ProductCategory/LgibHealthProductCategoryDetail"),
  {
    loading: () => <div />,
  }
);
const LgibHealthTopUpProductCategoryDetail = dynamic(
  () => import("../ProductCategory/LgibHealthTopUpProductCategoryDetail"),
  {
    loading: () => <div />,
  }
);
const AXAAdultHealthProductCategoryDetail = dynamic(
  () =>
    import(
      "../ProductCategory/AXAAdultHealthProductCategoryDetail/AXAAdultHealthProductCategoryDetail"
    ),
  {
    loading: () => <div />,
  }
);
const BKIPAProductCategoryDetail = dynamic(
  () =>
    import(
      "../ProductCategory/BKIPAProductCategoryDetail/BKIPAProductCategoryDetail"
    ),
  {
    loading: () => <div />,
  }
);
const MTIChildPAProductCategoryDetail = dynamic(
  () =>
    import(
      "../ProductCategory/MTIChildPAProductCategoryDetail/MTIChildPAProductCategoryDetail"
    ),
  {
    loading: () => <div />,
  }
);
const MTIChildPAHealthProductCategoryDetail = dynamic(
  () =>
    import(
      "../ProductCategory/MTIChildPAHealthProductCategoryDetail/MTIChildPAHealthProductCategoryDetail"
    ),
  {
    loading: () => <div />,
  }
);
const MTIPneumoniaDengueProductCategoryDetail = dynamic(
  () =>
    import(
      "../ProductCategory/MTIPneumoniaDengueProductCategoryDetail/MTIPneumoniaDengueProductCategoryDetail"
    ),
  {
    loading: () => <div />,
  }
);
const MTIWomenPAProductCategoryDetail = dynamic(
  () =>
    import(
      "../ProductCategory/MTIWomenPAProductCategoryDetail/MTIWomenPAProductCategoryDetail"
    ),
  {
    loading: () => <div />,
  }
);
const TIPPAProductCategoryDetail = dynamic(
  () =>
    import(
      "../ProductCategory/TIPPAProductCategoryDetail/TIPPAProductCategoryDetail"
    ),
  {
    loading: () => <div />,
  }
);
const AXACancerProductCategoryDetail = dynamic(
  () =>
    import(
      "../ProductCategory/AXACancerProductCategoryDetail/AXACancerProductCategoryDetail"
    ),
  {
    loading: () => <div />,
  }
);

export type ProductCategoryPagePropType = {
  channelPath: string;
  categoryCode: string;
  banner: BannerType;
  entryForm: {
    code: string;
    hero?: I18Text;
    activeInputCodes: ActiveInputCodesType[];
  };
  contentCode: string;
  channelConfig: ChannelConfigType;
};

const EntryForm = dynamic(() => import("../EntryForm/EntryForm"), {
  loading: () => <div />,
});

const ProductCategoryPage = ({
  channelPath,
  categoryCode,
  banner,
  entryForm,
  contentCode,
  channelConfig,
}: ProductCategoryPagePropType) => {
  const { content } = channelConfig;
  const EntryFormComponent = (
    <EntryForm
      categoryCode={categoryCode}
      entryFormCode={entryForm?.code}
      entryFormHero={entryForm?.hero}
      activeInputCodes={entryForm?.activeInputCodes}
      channelPath={channelPath}
      channelCode={channelConfig.code}
    />
  );

  const categoryCodeToProductCategory = {
    "content-ret-child-health": (
      <ChildHealthProductCategoryDetail entryForm={EntryFormComponent} />
    ),
    "content-ret-health": (
      <HealthProductCategoryDetail
        banner={banner}
        categoryCode={categoryCode}
        entryForm={entryForm}
        channelPath={channelPath}
        categoryName={banner.title}
        channelConfig={channelConfig}
      />
    ),
    "content-ret-health-topup": (
      <HealthTopUpProductCategoryDetail entryForm={EntryFormComponent} />
    ),
    "content-ret-personal-accident": (
      <PAProductCategoryDetail entryForm={EntryFormComponent} />
    ),
    "content-ret-critical-illness": (
      <CriticalIllnessProductCategoryDetail entryForm={EntryFormComponent} />
    ),
    "content-ret-cancer": (
      <CancerProductCategoryDetail entryForm={EntryFormComponent} />
    ),
    "content-ptn-thg-health": (
      <PartnerHealthProductCategoryDetail entryForm={EntryFormComponent} />
    ),
    "content-ptn-thg-health-topup": (
      <PartnerHealthTopupProductCategoryDetail entryForm={EntryFormComponent} />
    ),
    "content-ptn-thg-personal-accident": (
      <THGPAProductCateogryDetail entryForm={EntryFormComponent} />
    ),
    "content-ptn-thg-critical-illness": (
      <PartnerCriticalIllnessProductCategoryDetail
        entryForm={EntryFormComponent}
      />
    ),
    "content-ptn-siw-health": (
      <PartnerHealthProductCategoryDetail entryForm={EntryFormComponent} />
    ),
    "content-ptn-siw-health-topup": (
      <PartnerHealthTopupProductCategoryDetail entryForm={EntryFormComponent} />
    ),
    "content-ptn-siw-personal-accident": (
      <PartnerPAProductCategoryDetail entryForm={EntryFormComponent} />
    ),
    "content-ptn-siw-critical-illness": (
      <PartnerCriticalIllnessProductCategoryDetail
        entryForm={EntryFormComponent}
      />
    ),
    "content-ptn-wth-health": (
      <PartnerHealthProductCategoryDetail entryForm={EntryFormComponent} />
    ),
    "content-ptn-wth-health-topup": (
      <PartnerHealthTopupProductCategoryDetail entryForm={EntryFormComponent} />
    ),
    "content-ptn-wth-personal-accident": (
      <PartnerPAProductCategoryDetail entryForm={EntryFormComponent} />
    ),
    "content-ptn-wth-critical-illness": (
      <PartnerCriticalIllnessProductCategoryDetail
        entryForm={EntryFormComponent}
      />
    ),
    "content-ptn-fpd-health": (
      <PartnerHealthProductCategoryDetail entryForm={EntryFormComponent} />
    ),
    "content-ptn-fpd-health-topup": (
      <PartnerHealthTopupProductCategoryDetail entryForm={EntryFormComponent} />
    ),
    "content-ptn-fpd-personal-accident": (
      <PartnerPAProductCategoryDetail entryForm={EntryFormComponent} />
    ),
    "content-ptn-fpd-critical-illness": (
      <PartnerCriticalIllnessProductCategoryDetail
        entryForm={EntryFormComponent}
      />
    ),
    "content-ptn-lgi-health": (
      <LgibHealthProductCategoryDetail entryForm={EntryFormComponent} />
    ),
    "content-ptn-lgi-health-topup": (
      <LgibHealthTopUpProductCategoryDetail entryForm={EntryFormComponent} />
    ),
    "content-ptn-lgi-personal-accident": (
      <PartnerPAProductCategoryDetail entryForm={EntryFormComponent} />
    ),
    "content-ptn-lgi-critical-illness": (
      <PartnerCriticalIllnessProductCategoryDetail
        entryForm={EntryFormComponent}
      />
    ),
    "content-ptn-ntl-health": (
      <HGDHealthProductCategoryDetail entryForm={EntryFormComponent} />
    ),
    "content-ptn-ntl-health-topup": (
      <HGDHealthTopUpProductCategoryDetail entryForm={EntryFormComponent} />
    ),
    "content-ptn-ntl-personal-accident": (
      <HGDPAProductCategoryDetail entryForm={EntryFormComponent} />
    ),
    "content-ptn-ntl-critical-illness": (
      <HGDCriticalIllnessProductCategoryDetail entryForm={EntryFormComponent} />
    ),
    "content-scb-personal-accident-foreign-woker": (
      <ScbForeignWorkerPAProductCategoryDetail entryForm={EntryFormComponent} />
    ),
    "content-ptn-ksc-child-health": (
      <KSCChildHealthProductCategoryDetail entryForm={EntryFormComponent} />
    ),
    "content-ptn-ksc-health": (
      <KSCHealthProductCategoryDetail entryForm={EntryFormComponent} />
    ),
    "content-ptn-ksc-health-topup": (
      <KSCHealthTopUpProductCategoryDetail entryForm={EntryFormComponent} />
    ),
    "content-ret-motor-gasoline": (
      <RetailMotorProductCategoryDetail
        banner={banner}
        categoryCode={categoryCode}
        entryForm={EntryFormComponent}
        channelPath={channelPath}
        categoryName={banner.title}
        channelConfig={channelConfig}
      />
    ),
    "content-ret-motor-ev": (
      <EvRetailMotorProductCategoryDetail
        banner={banner}
        categoryCode={categoryCode}
        entryForm={EntryFormComponent}
        channelPath={channelPath}
        categoryName={banner.title}
        channelConfig={channelConfig}
      />
    ),
    "content-ret-chubb-travel": (
      <CHUBBTravelProductCategoryDetail
        banner={banner}
        categoryCode={categoryCode}
        entryForm={entryForm}
        channelPath={channelPath}
        categoryName={banner.title}
        channelConfig={channelConfig}
      />
    ),
    "content-axa-child-health": (
      <AXAChildHealthProductCategoryDetail
        banner={banner}
        categoryCode={categoryCode}
        entryForm={entryForm}
        channelPath={channelPath}
        categoryName={banner.title}
        channelConfig={channelConfig}
      />
    ),
    "content-axa-health": (
      <AXAAdultHealthProductCategoryDetail
        banner={banner}
        categoryCode={categoryCode}
        entryForm={entryForm}
        channelPath={channelPath}
        categoryName={banner.title}
        channelConfig={channelConfig}
      />
    ),
    "content-axa-cancer": (
      <AXACancerProductCategoryDetail
        banner={banner}
        categoryCode={categoryCode}
        entryForm={entryForm}
        channelPath={channelPath}
        categoryName={banner.title}
        channelConfig={channelConfig}
      />
    ),
    "content-bki-pa": (
      <BKIPAProductCategoryDetail
        banner={banner}
        categoryCode={categoryCode}
        entryForm={entryForm}
        channelPath={channelPath}
        categoryName={banner.title}
        channelConfig={channelConfig}
      />
    ),
    "content-mti-child-pa": (
      <MTIChildPAProductCategoryDetail
        banner={banner}
        categoryCode={categoryCode}
        entryForm={entryForm}
        channelPath={channelPath}
        categoryName={banner.title}
        channelConfig={channelConfig}
      />
    ),
    "content-mti-child-pa-health": (
      <MTIChildPAHealthProductCategoryDetail
        banner={banner}
        categoryCode={categoryCode}
        entryForm={entryForm}
        channelPath={channelPath}
        categoryName={banner.title}
        channelConfig={channelConfig}
      />
    ),
    "content-mti-pneumonia-dengue": (
      <MTIPneumoniaDengueProductCategoryDetail
        banner={banner}
        categoryCode={categoryCode}
        entryForm={entryForm}
        channelPath={channelPath}
        categoryName={banner.title}
        channelConfig={channelConfig}
      />
    ),
    "content-mti-women-pa": (
      <MTIWomenPAProductCategoryDetail
        banner={banner}
        categoryCode={categoryCode}
        entryForm={entryForm}
        channelPath={channelPath}
        categoryName={banner.title}
        channelConfig={channelConfig}
      />
    ),
    "content-tip-pa": (
      <TIPPAProductCategoryDetail
        banner={banner}
        categoryCode={categoryCode}
        entryForm={entryForm}
        channelPath={channelPath}
        categoryName={banner.title}
        channelConfig={channelConfig}
      />
    ),
  };

  const ProductCategoryDetailBox =
    get(categoryCodeToProductCategory, contentCode) || EntryFormComponent;

  return (
    <div>
      {!(
        entryForm.code === ENTRY_FORM_CODE.MOTOR_BASIC_ENTRY_FORM ||
        [
          "content-ret-health",
          "content-ret-chubb-travel",
          "content-axa-child-health",
          "content-axa-health",
          "content-bki-pa",
          "content-mti-child-pa",
          "content-mti-child-pa-health",
          "content-mti-pneumonia-dengue",
          "content-mti-women-pa",
          "content-tip-pa",
          "content-axa-cancer",
        ].includes(contentCode)
      ) && (
        <EntryFormBanner
          title={banner.title}
          desktopImage={banner.desktopImage}
          mobileImage={banner.mobileImage}
          content={content}
        />
      )}
      {ProductCategoryDetailBox}
      {![
        "content-ret-health",
        "content-ret-motor",
        "content-ret-chubb-travel",
        "content-axa-child-health",
        "content-axa-health",
        "content-bki-pa",
        "content-mti-child-pa",
        "content-mti-child-pa-health",
        "content-mti-pneumonia-dengue",
        "content-mti-women-pa",
        "content-tip-pa",
        "content-axa-cancer",
      ].includes(contentCode) && <ContactUs content={channelConfig.content} />}
    </div>
  );
};
export default ProductCategoryPage;
